import {
  getObjects,
  getObjectsWithParams,
  getObject,
  addObject,
  updateObject,
  deleteObject,
} from "./Api";

// IPD Admissions API
export const listIPDAdmissions = (params, token) => {
  return getObjectsWithParams("ipd-admissions", params, token);
};

export const getIPDAdmission = (id, token) => {
  return getObject("ipd-admissions", id, token);
};

export const createIPDAdmission = (data, token) => {
  return addObject("ipd-admissions", data, token);
};

export const updateIPDAdmission = (id, data, token) => {
  return updateObject("ipd-admissions", data, id, token);
};

export const deleteIPDAdmission = (id, token) => {
  return deleteObject("ipd-admissions", id, token);
};

export const getIPDDashboard = (token) => {
  return getObjects("ipd-admissions/dashboard", token);
};

export const getAvailableBeds = (params, token) => {
  return getObjectsWithParams("ipd-admissions/available-beds", params, token);
};

export const dischargePatient = (id, data, token) => {
  return addObject(`ipd-admissions/${id}/discharge`, data, token);
};

export const transferPatient = (id, data, token) => {
  return addObject(`ipd-admissions/${id}/transfer`, data, token);
};

export const getAdmissionCharges = (id, token) => {
  return getObject(`ipd-admissions/${id}/charges`, id, token);
};

export const addAdmissionCharge = (id, data, token) => {
  return addObject(`ipd-admissions/${id}/add-charge`, data, token);
};

// Admission details editing + audits
export const updateAdmissionDetails = (id, data, token) => {
  return addObject(`ipd-admissions/${id}/update-details`, data, token);
};

export const listAdmissionAudits = (id, token) => {
  return getObjects(`ipd-admissions/${id}/audits`, token);
};

// Ward Rounds API
export const listWardRounds = (params, token) => {
  return getObjectsWithParams("ward-rounds", params, token);
};

export const getWardRound = (id, token) => {
  return getObject("ward-rounds", id, token);
};

export const createWardRound = (data, token) => {
  return addObject("ward-rounds", data, token);
};

export const updateWardRound = (id, data, token) => {
  return updateObject("ward-rounds", data, id, token);
};

export const deleteWardRound = (id, token) => {
  return deleteObject("ward-rounds", id, token);
};

export const getTodayRounds = (params, token) => {
  return getObjectsWithParams("ward-rounds/today-rounds", params, token);
};

// Orders from Ward Rounds
export const createLabOrderFromRound = (roundId, data, token) => {
  return addObject(`ward-rounds/${roundId}/create-lab-order`, data, token);
};

export const createXrayFromRound = (roundId, data, token) => {
  return addObject(`ward-rounds/${roundId}/create-xray-order`, data, token);
};

export const createUltrasoundFromRound = (roundId, data, token) => {
  return addObject(
    `ward-rounds/${roundId}/create-ultrasound-order`,
    data,
    token
  );
};

// Ward Round Templates & Attachments
export const listWardRoundTemplates = (params, token) => {
  return getObjectsWithParams("ward-rounds/templates", params, token);
};

export const createWardRoundTemplate = (data, token) => {
  return addObject("ward-rounds/templates-create", data, token);
};

export const uploadWardRoundAttachment = (roundId, formData, token) => {
  // multipart; formData should contain: { file, caption? }
  return addObject(`ward-rounds/${roundId}/attachments`, formData, token, true);
};

// IPD Charges API
export const listIPDCharges = (params, token) => {
  return getObjectsWithParams("ipd-charges", params, token);
};

export const getIPDCharge = (id, token) => {
  return getObject("ipd-charges", id, token);
};

export const createIPDCharge = (data, token) => {
  return addObject("ipd-charges", data, token);
};

export const updateIPDCharge = (id, data, token) => {
  return updateObject("ipd-charges", data, id, token);
};

export const deleteIPDCharge = (id, token) => {
  return deleteObject("ipd-charges", id, token);
};

export const markChargePaid = (id, data, token) => {
  return addObject(`ipd-charges/${id}/mark-paid`, data, token);
};

// Investigations (from other modules)
export const listLabOrders = (params, token) => {
  return getObjectsWithParams("laboratory-test-orders", params, token);
};

export const listPatientXrays = (params, token) => {
  return getObjectsWithParams("patient-xray", params, token);
};

export const listUltrasounds = (params, token) => {
  return getObjectsWithParams("ultrasounds", params, token);
};

// Discharge Plans API
export const listDischargePlans = (params, token) => {
  return getObjectsWithParams("discharge-plans", params, token);
};

export const getDischargePlan = (id, token) => {
  return getObject("discharge-plans", id, token);
};

export const createDischargePlan = (data, token) => {
  return addObject("discharge-plans", data, token);
};

export const updateDischargePlan = (id, data, token) => {
  return updateObject("discharge-plans", data, id, token);
};

export const deleteDischargePlan = (id, token) => {
  return deleteObject("discharge-plans", id, token);
};

// IPD Transfers API
export const listIPDTransfers = (params, token) => {
  return getObjectsWithParams("ipd-transfers", params, token);
};

export const getIPDTransfer = (id, token) => {
  return getObject("ipd-transfers", id, token);
};

export const createIPDTransfer = (data, token) => {
  return addObject("ipd-transfers", data, token);
};

export const updateIPDTransfer = (id, data, token) => {
  return updateObject("ipd-transfers", data, id, token);
};

export const deleteIPDTransfer = (id, token) => {
  return deleteObject("ipd-transfers", id, token);
};
